/*ngInject*/
let AcquisitionSourceService = function ($rootScope, modals, AcquisitionSource, AcquisitionSourceConst) {
    this.edit = entity => {
        return modals.open('app/acquisition-source/edit-modal.html', 'AcquisitionSourceDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
    }
    this.add = () => {
        let entity = {
            active: true,
            id: null
        }
        return this.edit(entity)
    }
    this.remove = item => {
        return modals.confirmDelete(item.name, () => AcquisitionSource.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(AcquisitionSourceConst.eventUpdate)))
    }
};

/*ngInject*/
let AcquisitionSource = function ($resource) {
    return $resource('/crm/api/acquisition-source/:id', {}, {
        list: {method: 'GET', isArray: false},
        update: {method: 'PUT'},
        autocomplete: {method: 'GET', isArray: true, url: '/crm/api/acquisition-source/autocomplete'}
    })
};

/*ngInject*/
let AcquisitionSourceDialogController = function ($scope, $rootScope, $uibModalInstance, data, toastr, AcquisitionSource, AcquisitionSourceConst) {
    this.$onInit = () => {
        this.item = data
    }
    this.cancel = () => $uibModalInstance.dismiss('Canceled')
    this.save = () => {
        let promise
        if (this.item.id !== null) {
            promise = AcquisitionSource.update(this.item).$promise
        } else {
            promise = AcquisitionSource.save(this.item).$promise
        }
        return promise.then(result => {
            $rootScope.$broadcast(AcquisitionSourceConst.eventUpdate)
            $uibModalInstance.close(result)
            toastr.success("Zapisano")
        })
    }
};

/*ngInject*/
let AcquisitionSourceListController = function ($state, $scope, AcquisitionSourceService, AcquisitionSourceConst) {
    this.reset = () => this.filters = {}
    this.AcquisitionSourceService = AcquisitionSourceService
    $scope.$on(AcquisitionSourceConst.eventUpdate, () => $state.reload())
};

angular.module('acquisition-source', ['core'])
    .constant('AcquisitionSourceConst', {
        eventUpdate: 'acquisition-source.updated'
    })
    .factory('AcquisitionSource', AcquisitionSource)
    .service('AcquisitionSourceService', AcquisitionSourceService)
    .controller('AcquisitionSourceDialogController', AcquisitionSourceDialogController)
    .component('acquisitionSourceList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/acquisition-source/list.html',
        controller: AcquisitionSourceListController
    })
    .config(function ($stateProvider) {
        $stateProvider.state('acquisition-source', {
            parent: 'app',
            url: '/acquisition-source?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'acquisitionSourceList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (AcquisitionSource, $stateParams) => AcquisitionSource.list(angular.copy($stateParams)).$promise
            }
        })
    })
